import type {
  ComparisonCheckTone,
  ComparisonStatusKind,
  ComparisonStatusPresentation,
} from '~/features/homepage/constants/homepage-comparison-data';

export function getComparisonStatusPresentation(
  status: ComparisonStatusKind,
  checkTone: ComparisonCheckTone,
  isCompact?: boolean
): ComparisonStatusPresentation {
  if (status === 'full') {
    return checkTone === 'brand' ? 'brand-check' : 'neutral-check';
  }

  if (status === 'partial') {
    return isCompact ? 'partial-icon' : 'partial-text';
  }

  return 'none';
}
